import { employeeApi } from '@api/employeeApi';
import { useState, useEffect } from 'react';
import Select from 'react-select';

const UserLists = () => {
    const [users, setUsers] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const usersPerPage = 10;
    const [selectedUser, setSelectedUser] = useState(null);

    useEffect(() => {
        const fetchUserData = async () => {
            const response = await employeeApi.getUserList();
            setUsers(response);
            setSelectedUser(response[0]);
        };

        fetchUserData();
    }, []);

    const handleUserClick = user => {
        setSelectedUser({
            ...selectedUser,
            name: user.displayName,
            role: user.roleNames,
        });
    };

    const filteredUsers = users.filter(user =>
        user.displayName.toLowerCase().includes(searchTerm.toLowerCase()),
    );

    const indexOfLastUser = currentPage * usersPerPage;
    const indexOfFirstUser = indexOfLastUser - usersPerPage;
    const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);

    const totalPages = Math.ceil(filteredUsers.length / usersPerPage);

    const handlePageChange = pageNumber => {
        setCurrentPage(pageNumber);
    };

    const handleSearchChange = e => {
        setSearchTerm(e.target.value);
        setCurrentPage(1);
    };

    // Function to get the range of page numbers to display
    const getPaginationRange = () => {
        const range = [];
        const start = Math.max(1, currentPage - 2);
        const end = Math.min(totalPages, start + 4);

        for (let i = start; i <= end; i++) {
            range.push(i);
        }
        return range;
    };

    return (
        <div className="flex h-screen gap-8">
            <div className="w-8/12 ">
                <div className="bg-white rounded-lg shadow-md p-4">
                    <h2 className="text-lg font-semibold mb-4">Users list</h2>
                    <input
                        type="text"
                        placeholder="Search users..."
                        value={searchTerm}
                        onChange={handleSearchChange}
                        className="mb-4 p-2 border rounded-md"
                    />
                    <table className="min-w-full">
                        <thead>
                            <tr>
                                <th className="px-3 py-2 text-left">Name</th>
                                <th className="px-3 py-2 text-left">Job Title</th>
                                <th className="px-3 py-2 text-left">User Role</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentUsers.map((user, index) => (
                                <tr
                                    key={index}
                                    className="hover:bg-gray-100 cursor-pointer"
                                    onClick={() => handleUserClick(user)}
                                >
                                    <td className="py-2 px-3">{user.displayName}</td>
                                    <td className="py-2 px-3 text-sm">{user.jobTitle}</td>
                                    <td className="py-2 px-3 text-sm">{user.roleNames}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div className="flex justify-center mt-4">
                        <button
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                            className="mx-1 p-2 border rounded-md bg-white"
                        >
                            Prev
                        </button>
                        {getPaginationRange().map(page => (
                            <button
                                key={page}
                                onClick={() => handlePageChange(page)}
                                className={`mx-1 p-2 border rounded-md ${
                                    currentPage === page ? 'bg-blue-600 text-white' : 'bg-white'
                                }`}
                            >
                                {page}
                            </button>
                        ))}
                        <button
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            className="mx-1 p-2 border rounded-md bg-white"
                        >
                            Next
                        </button>
                    </div>
                </div>
            </div>

            <div className="w-4/12 ">
                <div className="bg-white rounded-lg shadow-md p-6">
                    {selectedUser ? (
                        <>
                            <h2 className="text-lg font-semibold mb-4">{selectedUser.name}</h2>
                            <div className="mb-4">
                                <label className="block text-sm font-medium mb-1">Name</label>
                                <p className="text-gray-600">{selectedUser.name}</p>
                            </div>

                            <div className="mb-4">
                                <label className="block text-sm font-medium mb-1">Role</label>
                                <Select
                                    value={selectedUser.role.map(role => ({
                                        value: role,
                                        label: role,
                                    }))}
                                    onChange={selectedOptions => {
                                        const selectedRoles = selectedOptions.map(
                                            option => option.value,
                                        );
                                        setSelectedUser({ ...selectedUser, role: selectedRoles });
                                    }}
                                    options={[
                                        { value: '1', label: 'Employee' },
                                        { value: '2', label: 'Admin' },
                                        { value: '3', label: 'Manager' },
                                        { value: '4', label: 'Recruiter' },
                                        { value: '5', label: 'HR' },
                                    ]}
                                    isMulti
                                    className="w-full"
                                />
                            </div>

                            <button
                                className="w-full bg-blue-600 text-white py-2 rounded-md"
                                onClick={async () => {
                                    if (selectedUser) {
                                        const roleId = selectedUser.role; // Assuming you want to update with the first selected role
                                        const userId = selectedUser.id; // Ensure you have the userId available
                                        await employeeApi.updateUserRole(roleId, userId);
                                    }
                                }}
                            >
                                Save
                            </button>
                        </>
                    ) : (
                        <h2 className="text-lg font-semibold mb-4">No Users Selected</h2>
                    )}
                </div>
            </div>
        </div>
    );
};

export { UserLists };
